module.exports = __webpack_public_path__ + "1112f977df34c378324bd731be1b644e.mp4";